import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-scroll';
import './Hero.css';

const fadeUp = (delay = 0) => ({
  initial: { opacity: 0, y: 40 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.7, delay, ease: 'easeOut' },
});

export default function Hero() {
  return (
    <section className="hero" id="hero">
      {/* Animated background grid */}
      <div className="hero__grid" />
      <div className="hero__glow hero__glow--1" />
      <div className="hero__glow hero__glow--2" />

      <div className="container hero__content">
        <motion.div className="tag" {...fadeUp(0.1)}>
          ⚡ Минск, Беларусь — Инжиниринг &amp; IT
        </motion.div>

        <motion.h1 className="hero__title" {...fadeUp(0.25)}>
          ЭНЕРГО
          <span className="hero__title-accent">ГЛАЙД</span>
        </motion.h1>

        <motion.p className="hero__subtitle" {...fadeUp(0.45)}>
          Комплексные услуги в сфере инжиниринга, проектирования
          <br />
          и информационных технологий.
          <br />
          Веб, Desktop (Windows / macOS / Linux), геодезия, электроснабжение.
        </motion.p>

        <motion.div className="hero__actions" {...fadeUp(0.6)}>
          <Link to="services" smooth duration={600} offset={-80}>
            <button className="btn btn-primary hero__btn">
              Наши услуги
            </button>
          </Link>
          <Link to="contacts" smooth duration={600} offset={-80}>
            <button className="btn btn-outline hero__btn">
              Связаться
            </button>
          </Link>
        </motion.div>

        <motion.div className="hero__stats" {...fadeUp(0.75)}>
          <div className="hero__stat">
            <span className="hero__stat-number">10+</span>
            <span className="hero__stat-label">Услуг</span>
          </div>
          <div className="hero__stat-divider" />
          <div className="hero__stat">
            <span className="hero__stat-number">2</span>
            <span className="hero__stat-label">Направления</span>
          </div>
          <div className="hero__stat-divider" />
          <div className="hero__stat">
            <span className="hero__stat-number">4+</span>
            <span className="hero__stat-label">Платформы</span>
          </div>
        </motion.div>
      </div>

      <div className="hero__scroll-hint">
        <motion.div
          animate={{ y: [0, 8, 0] }}
          transition={{ repeat: Infinity, duration: 1.6 }}
        >
          ↓
        </motion.div>
      </div>
    </section>
  );
}
